<div class="c__header" role="banner">
  @if (!isSimplified && deliveryContactData?.length > 0) {
    <div class="c__header-top">
      @if (!isDevice$) {
        <sd-header-reinsurances [reinsurancesData]="deliveryContactData" />
      }
    </div>
  }

  @if (!!discoverBrandsText && !isSimplified) {
    <sd-discover-banner [discoverBrandsText]="discoverBrandsText" />
  }

  <div class="c__header-main-content">
    <div class="c__header-content" (mouseenter)="onClickOverlay()">

      <!-- HEADER ORDER TUNNEL -->
      @if (isSimplified) {
        <a sd-button
          class="c__back-button"
          [isSmall]="true"
          icon="icon-arrow-left"
          (click)="goBack()"
          [isSecondary]="true"
        >
          <span>{{ (isMobile$ ? 'navigation.checkout.backMobile' : 'navigation.checkout.back') | translate}}</span>
        </a>
      }

      @if (logoLink && isSimplified) {
        <div class="c__logo is-simplified">
          @for (tabBrand of tabsBrands; track tabBrand.brand) {
            @let brand = tabBrand.brand.toLowerCase();
            <img [src]="urlIcons + 'commons/icon-brand-' + brand + '.svg'" [alt]="brand" />
          }
          <span class="is-visually-hidden">{{'navigation.a11y.brandHomepage' | translate}}</span>
        </div>
      }

      <!-- END HEADER ORDER TUNNEL -->
      @if (!isSimplified) {
        <div class="c__brand-selector">
          @for (tabBrand of tabsBrands; track tabBrand.brand) {
            @let brand = tabBrand.brand.toLowerCase();
            <div class="c__brand-selector-item {{tabBrand.brand === activeBrand ? 'is-selected' : ''}}">
              <a [href]="tabBrand['url']" (click)="selectBrand(tabBrand.brand)">
                <img [src]="urlIcons + 'commons/icon-brand-' + brand + '.svg'" [alt]="brand" />
                <span class="is-visually-hidden">{{'navigation.a11y.brandHomepage' | translate}}</span>
              </a>
            </div>
          }
        </div>
      }

      <div class="c__wrapper-search-and-info">
        @if (!isDevice$ && languageSelectorData && !isSimplified) {
          <div class="c__language-wrapper">
            <sd-language-selector
              [languages]="languageSelectorData.languages"
              [hasPipe]="true"
              [activeIsoCode]="languageSelectorData.activeIsoCode"
              (languageSelected)="changeLanguage($event)"
            />
          </div>
        }

        @if (!isDevice$ && !isSimplified) {
          <sd-search
            class="c__search"
            [searchData]="searchData?.data"
            [inputMinLength]="inputMinLength"
            [pushTemplate]="pushHeaderTemplate1"
            (clearInputSearch)="onClearInputSearch()"
            (submitInputSearch)="onSubmitSearch($event)"
            (inputSearch)="onSearch($event)"
            (openSearch)="onOpenedSearch($event)"
            (openRecommendedPriceModal)="onopenRecommendedPriceModal()"
          >
            <ng-template #pushHeaderTemplate1>
              <ng-container *ngTemplateOutlet="pushTemplate" />
            </ng-template>
          </sd-search>
        }
        <div class="c__informations">
          @if (iconLinks && !isDevice$) {
            @for (iconLink of iconLinks; track iconLink) {
              @if (!iconLink.isMobile) {
                <div class="c__information">
                  <sd-link
                    [icon]="iconLink.iconName"
                    [size]="IconSizeEnum.small"
                    [iconPos]="PositionEnum.left"
                    [titleHidden]="true"
                    role="button"
                    customClass="has-label"
                    [buttonIconTitle]="iconLink.link?.linkName"
                    [link]="iconLink.link"
                  >
                    <span class="c__icon-label">
                      {{iconLink.link?.linkName}}
                    </span>
                  </sd-link>
                </div>
              }
            }
          }

          @if (dropdownHelpData && !isDevice$) {
            <sd-dropdown-help
              class="c__information"
              [brand]="BrandsEnum.hob"
              [links]="dropdownHelpData"
            />
          }

          @if (dropdownAccountData && !isDevice$) {
            <sd-dropdown-account
              class="c__information"
              [account]="dropdownAccountData?.account"
              [isLoggedIn]="dropdownAccountData?.loggedIn"
              [brand]="BrandsEnum.hob"
              (signUp)="onSignUp()"
              (login)="onLogin()"
              (logout)="onLogout()"
              (isOpenedChange)="isAccountOpenedChange.emit($event)"
            />
          }

          @if (dropdownCartData && !isDevice$) {
            <sd-dropdown-cart
              class="c__information"
              [cartData]="dropdownCartData"
              [brand]="BrandsEnum.hob"
              (empty)="onEmptyCart()"
              (quantity)="onQuantityChange($event)"
              (delete)="onDelete($event)"
              (promoClick)="onClickPromo($event)"
              (openRecommendedPriceModal)="onopenRecommendedPriceModal()"
              (isOpenedChange)="isCartOpenedChange.emit($event)"
            />
          }
        </div>
      </div>
    </div>

    @if (!isSimplified) {
      <div class="c__wrapper-menu">
        <sd-menu
          class="{{showOverlay ? 'is-open' : ''}}"
          #menuComponent
          [menuData]="menuDataConfig?.menuData"
          [iconLinks]="iconLinks"
          [languageSelectorData]="languageSelectorData"
          [activeCatId]="menuDataConfig?.activeCatId"
          (linkClicked)="onLinkClicked($event)"
          (pushCardClicked)="onPushCardClicked($event)"
          (clickCardFrames)="onClickCardFrames($event)"
          (isMenuOpen)="onMenuOpenedChanged($event)"
          (clickNavigation)="onClickMenu($event)"
          (languageSelected)="changeLanguage($event)"
        />

        @if (isDevice$) {
          <sd-search
            class="c__search"
            [openMobileSearch]="openMobileSearch.asObservable()"
            [hasFormToggle]="true"
            [searchData]="searchData?.data"
            [pushTemplate]="pushHeaderTemplate2"
            (submitInputSearch)="onSubmitSearch($event)"
            (inputSearch)="onSearch($event)"
            (openSearch)="onOpenedSearch($event)"
            (openRecommendedPriceModal)="onopenRecommendedPriceModal()"
          >
            <ng-template #pushHeaderTemplate2>
              <ng-container *ngTemplateOutlet="pushTemplate" />
            </ng-template>
          </sd-search>
        }

        <div class="c__informations">
          @if (dropdownAccountData && isDevice$) {
            <sd-dropdown-account
              class="c__information"
              [account]="dropdownAccountData?.account"
              [isLoggedIn]="dropdownAccountData?.loggedIn"
              [brand]="BrandsEnum.hob"
              (signUp)="onSignUp()"
              (login)="onLogin()"
              (logout)="onLogout()"
              (isOpenedChange)="isAccountOpenedChange.emit($event)"
            />
          }

          @if (dropdownCartData && isDevice$) {
            <sd-dropdown-cart
              class="c__information"
              [cartData]="dropdownCartData"
              [brand]="BrandsEnum.hob"
              (empty)="onEmptyCart()"
              (quantity)="onQuantityChange($event)"
              (delete)="onDelete($event)"
              (promoClick)="onClickPromo($event)"
              (openRecommendedPriceModal)="onopenRecommendedPriceModal()"
              (isOpenedChange)="isCartOpenedChange.emit($event)"
            />
          }
        </div>
      </div>
    }

    @if (!isSimplified && showPageNavigation) {
      <sd-page-navigation
        [@fadeInOut]="!menuHidden ? '0' : '1'"
        [showLogo]="false"
        [title]="pageNavigationData?.title"
        [product]="pageNavigationData?.product"
        [links]="pageNavigationData?.links"
        [isBundle]="isBundle"
        [isSSR]="isSSR"
        (cart)="onAddToCart()"
        (notify)="onNotify()"
        (favorite)="onAddToFavorite()"
        (openRecommendedPriceModal)="onopenRecommendedPriceModal()"
      />
    }

    @if (!isSimplified) {
      <sd-brand-bar [brand]="activeBrand" />
    }
  </div>
</div>

@if (showOverlay) {
  <div class="c__menu-overlay" (click)="onClickOverlay()" (mousemove)="onClickOverlay()"></div>
}
